import React from 'react';
import { Image } from '../../atoms/Image';
import PropTypes from 'prop-types';

import desktopLanding from '../../../assets/images/headers/desktop/landing.svg';
import mobileLanding from '../../../assets/images/headers/mobile/landing.svg';

import desktopPathway from '../../../assets/images/headers/desktop/pathway.svg';
import mobilePathway from '../../../assets/images/headers/mobile/pathway.svg';

import desktopBarrierActivity from '../../../assets/images/headers/desktop/barrier/activity.svg';
import mobileBarrierActivity from '../../../assets/images/headers/mobile/barrier/activity.svg';

import desktopBarrierAlcohol from '../../../assets/images/headers/desktop/barrier/alcohol.svg';
import mobileBarrierAlcohol from '../../../assets/images/headers/mobile/barrier/alcohol.svg';

import desktopBarrierSmoking from '../../../assets/images/headers/desktop/barrier/smoking.svg';
import mobileBarrierSmoking from '../../../assets/images/headers/mobile/barrier/smoking.svg';

import desktopBarrierWeight from '../../../assets/images/headers/desktop/barrier/weight.svg';
import mobileBarrierWeight from '../../../assets/images/headers/mobile/barrier/weight.svg';

import desktopActionPlanActivity from '../../../assets/images/headers/desktop/action-plan/activity.svg';
import mobileActionPlanActivity from '../../../assets/images/headers/mobile/action-plan/activity.svg';

import desktopActionPlanAlcohol from '../../../assets/images/headers/desktop/action-plan/alcohol.svg';
import mobileActionPlanAlcohol from '../../../assets/images/headers/mobile/action-plan/alcohol.svg';

import desktopActionPlanSmoking from '../../../assets/images/headers/desktop/action-plan/smoking.svg';
import mobileActionPlanSmoking from '../../../assets/images/headers/mobile/action-plan/smoking.svg';

import desktopActionPlanWeight from '../../../assets/images/headers/desktop/action-plan/weight.svg';
import mobileActionPlanWeight from '../../../assets/images/headers/mobile/action-plan/weight.svg';

import desktopBCTActivity from '../../../assets/images/headers/desktop/bct/activity.svg';
import mobileBCTActivity from '../../../assets/images/headers/mobile/bct/activity.svg';

import desktopBCTAlcohol from '../../../assets/images/headers/desktop/bct/alcohol.svg';
import mobileBCTAlcohol from '../../../assets/images/headers/mobile/bct/alcohol.svg';

import desktopBCTSmoking from '../../../assets/images/headers/desktop/bct/smoking.svg';
import mobileBCTSmoking from '../../../assets/images/headers/mobile/bct/smoking.svg';

import desktopBCTWeight from '../../../assets/images/headers/desktop/bct/weight.svg';
import mobileBCTWeight from '../../../assets/images/headers/mobile/bct/weight.svg';
import useMediaQuery from '../../../hooks/useMediaQuery';

function getImage(device, type) {
    switch (type) {
        case 'landing':
            return device === 'desktop' ? desktopLanding : mobileLanding;
        case 'pathway':
            return device === 'desktop' ? desktopPathway : mobilePathway;

        case 'barrier-activity':
            return device === 'desktop' ? desktopBarrierActivity : mobileBarrierActivity;
        case 'barrier-alcohol':
            return device === 'desktop' ? desktopBarrierAlcohol : mobileBarrierAlcohol;
        case 'barrier-smoking':
            return device === 'desktop' ? desktopBarrierSmoking : mobileBarrierSmoking;
        case 'barrier-weight':
            return device === 'desktop' ? desktopBarrierWeight : mobileBarrierWeight;

        case 'action-plan-activity':
            return device === 'desktop' ? desktopActionPlanActivity : mobileActionPlanActivity;
        case 'action-plan-alcohol':
            return device === 'desktop' ? desktopActionPlanAlcohol : mobileActionPlanAlcohol;
        case 'action-plan-smoking':
            return device === 'desktop' ? desktopActionPlanSmoking : mobileActionPlanSmoking;
        case 'action-plan-weight':
            return device === 'desktop' ? desktopActionPlanWeight : mobileActionPlanWeight;

        case 'bct-activity':
            return device === 'desktop' ? desktopBCTActivity : mobileBCTActivity;
        case 'bct-alcohol':
            return device === 'desktop' ? desktopBCTAlcohol : mobileBCTAlcohol;
        case 'bct-smoking':
            return device === 'desktop' ? desktopBCTSmoking : mobileBCTSmoking;
        case 'bct-weight':
            return device === 'desktop' ? desktopBCTWeight : mobileBCTWeight;

        default:
            return device === 'desktop' ? desktopLanding : mobileLanding;
    }
}

function Illustration({ type, classes }) {
    const media = useMediaQuery('(min-width: 768px)');
    const device = media ? 'desktop' : 'mobile';
    return (
        <div className="h-auto position-relative">
            <Image src={getImage(device, type)} alt={`${type}-background`} imgClass={classes} />
        </div>
    );
}

Illustration.propTypes = {
    type: PropTypes.string,
    classes: PropTypes.string,
};

Illustration.defaultProps = {
    type: 'landing',
    classes: '',
};

export default Illustration;
